import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import ExpenseListResults from 'components/Expenses/ExpenseListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  expenses: state.expenses,
  expenseTypes: state.expenseTypes,
  employees: state.employees,
  idGen: state.idGen,
  user: state.user
});

const ExpenseList = (props) => (
  <>
    <Helmet>
      <title>Expenses | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
          <ExpenseListResults
            activeUserId={props.activeUserId}
            activeUserType={props.activeUserType}
            expenses={props.expenses}
            expenseTypes={props.expenseTypes}
            employees={props.employees}
            idGen={props.idGen}
            user={props.user}
          />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (ExpenseList);
